<template>
  <el-dialog
    title="Upload"
    :visible="dialog_upload"
    width="500px"
    top="3vh"
    :modal="true"
    @close="close"
  >
    <el-upload
      drag
      ref="upload"
      :action="`${url}import/upload`"
      :headers="headers"
      accept=".mp3"
      :file-list="fileList"
      :on-success="onSuccess"
      :on-error="onError"
      :on-progress="uploadFile"
      name="uploaded"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <div class="el-upload__tip" slot="tip">*only mp3 files allowed</div>
    </el-upload>
    <div class="mt20" v-if="startUpload">
      <i class="fa fa-spinner fa-spin"></i> Uploading file to Amazon S3 and Cyanite...
    </div>
    <div slot="footer">
      <el-button type="danger" size="mini" @click="setDialogUpload(false)">
        Close
      </el-button>
    </div>
    <!-- <el-button type="primary" @click="upload">Upload</el-button> -->
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      fileList: [],
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      url: process.env.VUE_APP_ADMIN_API_URL,
      startUpload: false
    }
  },

  computed: {
    ...mapState('trackImport', ['dialog_upload']),
    ...mapState('newReleasesArtists', ['artists'])
  },

  methods: {
    ...mapMutations('trackImport', ['setDialogUpload']),
    ...mapActions('trackImport', { readTracks: 'read' }),
    ...mapActions('newReleasesArtists', { readArtists: 'read' }),

    onSuccess() {
      this.readTracks()
      this.startUpload = false
      this.setDialogUpload(false)
    },
    onError(err) {
      var res = JSON.parse(err.message)
      this.startUpload = false
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },
    uploadFile() {
      this.startUpload = true
    },
    close(){
      this.fileList = []
      this.setDialogUpload(false)      
    }
  },

  created() {
    this.readArtists()
  }
}
</script>
